module.exports = __webpack_public_path__ + "static/img/ftp_test.a1681a12.png";